import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define the API service for OREStitching
export const oreStitchingApi = createApi({
  reducerPath: 'oreStitchingApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Stitching'], // Define the tag type for cache management and invalidation
  endpoints: (builder) => ({
    // Define the endpoints for your API
    findAllStitchings: builder.query({
      query: (company) => `stitching/${company}`, // GET all stitching entries by company
      providesTags: ['Stitching'] // Cache with the 'Stitching' tag
    }),
    findStitchingById: builder.query({
      query: (id) => `stitching/byid/${id}`, // GET stitching entry by ID
      providesTags: ['Stitching'] // Cache with the 'Stitching' tag
    }),
    insertStitching: builder.mutation({
      query: (stitching) => ({
        url: 'stitching', // POST a new stitching entry
        method: 'POST',
        body: stitching
      }),
      invalidatesTags: ['Stitching'] // Invalidate the 'Stitching' tag cache
    }),
    updateStitching: builder.mutation({
      query: (stitching) => ({
        url: 'stitching', // PUT update stitching entry
        method: 'PUT',
        body: stitching
      }),
      invalidatesTags: ['Stitching'] // Invalidate the 'Stitching' tag cache
    }),
    deleteStitching: builder.mutation({
      query: (id) => ({
        url: `stitching/${id}`, // DELETE a stitching entry by ID
        method: 'DELETE'
      }),
      invalidatesTags: ['Stitching'] // Invalidate the 'Stitching' tag cache
    })
  })
});

// Export the auto-generated hooks for the endpoints
export const {
  useFindAllStitchingsQuery,
  useFindStitchingByIdQuery,
  useInsertStitchingMutation,
  useUpdateStitchingMutation,
  useDeleteStitchingMutation
} = oreStitchingApi;
